import {PayloadAction} from "@reduxjs/toolkit";
import {Reducer} from "redux";
import {ICategoryProvider} from "../../model/ICategoryProvider";
import {LocalCategoryProvider} from "../../model/LocalCategoryProvider";
import {NODE_FETCH} from "../node/nodeActions";
import {CATALOG_CLEAR, CATALOG_FETCH} from "./catalogActions";
import {getActionExtras} from "../../middlewares/action-decorator/actionDecoratorMiddlewareFactory";
import {REQUEST_INIT, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";

export type CatalogState = ICategoryProvider | null;

const catalogReducer: Reducer<CatalogState, PayloadAction<any>> = (state = null, action) => {
  switch (action.type) {
    case CATALOG_CLEAR: {
      return null;
    }
    case REQUEST_INIT: {
      switch (action.payload.label) {
        case NODE_FETCH:
        case CATALOG_FETCH: {
          return null;
        }
        default:
          return state;
      }
    }
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case CATALOG_FETCH: {
          const t = getActionExtras(action)?.t;

          return new LocalCategoryProvider(
            action.payload.response.categoryGroups,
            action.payload.response.datasetMap,
            action.payload.response.datasetUncategorized,
            action.payload.extra.nodeId,
            action.payload.response.catalogLayers,
            t
          );
        }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default catalogReducer;
